import { domain, token } from "../../../../../components/Security";
import axios from "../../../../../api/apiClient";
import { useEffect, useState } from "react";
import { SetPayTypeId } from "../utils/SetPayTypeId";

export function PayTypeIdSelect({ payTypeId, setPayTypeId }) {
	const [isSelected, setIsSelected] = useState(false);

	const handleSelectChange = (event) => {
		setIsSelected(true);
		setPayTypeId(event.target.value);
	};

	const [data, setData] = useState([]);

	const fetchData = async () => {
		const apiUrl = domain + "/api/PayType/active";

		await axios
			.get(apiUrl, {
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json", // You can include other headers if needed
				},
			})
			.then((response) => {
				setData(response.data); // Set the response data to the state
			})
			.catch((error) => {
				console.error("Error fetching data:", error);
			});
	};

	useEffect(() => {
		fetchData();
		if (payTypeId !== "" && payTypeId !== 0) {
			setIsSelected(true);
		} else {
			setIsSelected(false);
		}
	}, [payTypeId]);

	return (
		<div>
			<select
				id="employee-select-PagibigReport"
				value={payTypeId}
				onChange={handleSelectChange}
				style={{
					color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
				}}
			>
				<option value="" disabled hidden>
					Choose pay type
				</option>
				{data.map((payTypeId) => SetPayTypeId(payTypeId))}
			</select>
		</div>
	);
}